// src/services/instances/season.ts
import apiClient from '@/services/api/apiClient';
import { QueryParams } from '@/model';
import { buildApiUrl } from '../utils';

import {
  GetSeasonResponse,
  GetSeasonByIdResponse,
  PostSeasonResponse,
  PutSeasonCurrentStageResponse,
  PutSeasonResponse,
} from '../response/season';

import { PostSeasonRequest, PutSeasonCurrentStageRequest, PutSeasonRequest } from '../request/season';

export class SeasonService {
  static getSeasons(params?: QueryParams) {
    return apiClient.get<GetSeasonResponse>(buildApiUrl('/api/v1/competitions/seasons'), params);
  }

  static postSeason(data: PostSeasonRequest) {
    return apiClient.post<PostSeasonResponse>(buildApiUrl('/api/v1/competitions/seasons'), data);
  }

  static putSeason(id: string, data: PutSeasonRequest) {
    return apiClient.update<PutSeasonResponse>(buildApiUrl('/api/v1/competitions/seasons/:id', { id }), data);
  }

  static getSeasonById(id: string) {
    return apiClient.get<GetSeasonByIdResponse>(buildApiUrl('/api/v1/competitions/seasons/:id', { id }), undefined);
  }

  static deleteSeason(id: string) {
    return apiClient.delete<void>(buildApiUrl('/api/v1/competitions/seasons/:id', { id }), undefined);
  }

  static putSeasonCurrentStage(id: string, data: PutSeasonCurrentStageRequest) {
    return apiClient.update<PutSeasonCurrentStageResponse>(buildApiUrl('/api/v1/competitions/seasons/:id/current-stage', { id }), data);
  }
}
